/* eslint-disable react/require-default-props */
import React, { InputHTMLAttributes } from 'react';
import styled from 'styled-components';
import { useSelector } from 'react-redux';

const StyledButton = styled.button<{ color?: string }>`
  width: 100%;
  font-family: inherit;
  border-radius: 4px;
  padding: 12px;
  font-size: 1rem;
  font-weight: bold;
  line-height: 18px;
  outline: none;
  color: #FFF;
  border: none;
  background-color: ${({ color }) => (color)};
  transition: opacity 400ms;
  cursor: pointer;
  transition: opacity 0.2s;

  &:disabled, &:hover > &:disabled {
    opacity: 0.4 !important;
    cursor: not-allowed;
  }

  &:hover {
    opacity: 0.8;
  }
`;

interface ButtonProps extends InputHTMLAttributes<HTMLButtonElement> {
  color?: string;
  type: 'submit' | 'reset' | 'button';
}

const ModalButton = (props: ButtonProps) => {
  const { color } = props;
  const { themeColor } = useSelector((state) => state.eventConfigs);

  return <StyledButton {...props} color={color || themeColor} />;
};

export default ModalButton;
